export default "__VITE_ASSET__SBE3j42j__"